import React, {ReactFragment, useContext} from "react";
import {createUseStyles} from "react-jss";
import JoinInstructions from "./shared/JoinInstructions";
import GetReady from "./common/GetReady";
import InProgress from "./shared/InProgress";
import HostBubbleContextProvider from "../contexts/HostBubbleContext";
import {HostBubble} from "./common/HostBubble";
import {EngageAppContext} from "../App";
import {TriviaStatus} from "../state/state";
import Background, {BackgroundType} from "engage-client/components/Background";
import Waiting from "./player/Waiting";
import ChatContextProvider from "../contexts/ChatContext";

const useStyles = createUseStyles({
	shared: {
		width:"100%",
		height: "100%",
	}
});

type SharedProps = {showLogo:boolean, sharedDisplay:boolean};

export default function Shared({showLogo , sharedDisplay}: SharedProps) {
	const {appState} = useContext(EngageAppContext.current);
	const classes = useStyles();

	let content: ReactFragment;
	
	if(appState.common.state === TriviaStatus.Pending) {
		if(sharedDisplay) {
			content = <JoinInstructions/>;
		} else {
		 	content = <Waiting/>;
		}

	} else if(appState.common.state === TriviaStatus.Starting) {
		content = <GetReady sharedDisplay={sharedDisplay}/>;
	} else {
		content = <InProgress sharedDisplay={sharedDisplay}/>;
	}

	let type:BackgroundType = BackgroundType.Main;
	if(appState.common.state === TriviaStatus.Pending) {
		type = BackgroundType.Welcome;
	} else if(appState.common.state === TriviaStatus.Starting) {
		type = BackgroundType.GetStarted;
	}
	return (
		<Background type={type} showLogo={showLogo} showSponsor={showLogo}>
			<HostBubbleContextProvider>
				<ChatContextProvider>
					<div className={classes.shared}>
						{content}
					</div>
					<HostBubble mute={true} />
				</ChatContextProvider>
			</HostBubbleContextProvider>
		</Background>
	);

};
